import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import QuoteForm from "@/components/site/QuoteForm";

export const QuoteDialog = ({ open, onOpenChange, defaultProduct }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="quote-dialog"
        className="max-w-2xl bg-white border-[var(--mn-line)] p-0 overflow-hidden"
      >
        <div className="bg-[var(--mn-black)] text-white px-7 py-6">
          <DialogHeader>
            <DialogTitle className="font-serif-display font-extrabold text-2xl text-white">
              Solicite seu orçamento
            </DialogTitle>
            <DialogDescription className="text-white/65 mt-1">
              Receba uma proposta personalizada em poucas horas — sem compromisso.
            </DialogDescription>
          </DialogHeader>
        </div>
        <div className="p-6">
          <QuoteForm compact defaultProduct={defaultProduct} testIdPrefix="qfd" />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteDialog;
